module.exports = __webpack_public_path__ + "img/ss-11.1373d2e6.png";